import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateUpdateUser = {
  updateUser: { data: null, loading: false, error: null },
};

export const updateUser = createAsyncThunk('user/updateUser', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .put(
      `${process.env.REACT_APP_SERVER_API}/users/${data.id}`,
      { full_name: data.fullName, phone: data.phone },
      {
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      },
    )
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerUpdateUser = {
  [updateUser.pending]: (state) => {
    state.updateUser.loading = true;
    state.updateUser.error = null;
  },
  [updateUser.fulfilled]: (state, action) => {
    state.updateUser.loading = false;
    state.updateUser.data = true;
    state.updateUser.error = null;
  },
  [updateUser.rejected]: (state, action) => {
    state.updateUser.loading = false;
    state.updateUser.error = action.payload;
  },
};
